export default __webpack_public_path__ + "static/summer_containers87-59bacb5d24ae167687d81da929d4f27d.webp";